export default __webpack_public_path__ + "img/mpc-mobile.b72b4f14.png";